import React, { Component, memo } from 'react';

import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { IaCreators } from '../../../../store/actions/intelligence';
import { BotsCreators } from '../../../../store/actions/bots';

import './SettingsCard.scss';
import menu from '../../img/menu.svg';
import edit from '../../img/edit.svg';
import delet from '../../img/icon_delete.svg';
import { UserActions } from '../../../../store/actions/users';

class SettingsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setting: false,
    };
  }

  isSetting = () => {
    this.setState({
      setting: !this.state.setting,
    });
  };

  executeFunction = (f) => {
    this.setState({
      setting: false,
    });
    f();
  };

  render() {
    const { setting } = this.state;
    const { blt, deleteItem, editItem, user } = this.props;
    return (
      <div>
        <img
          className={
            blt === 'condicoes' ? 'settings-card-condicoes' : 'settings-card'
          }
          src={menu}
          alt="menu"
          onClick={this.isSetting}
        />
        {setting === true && (
          <div
            className={
              blt === 'condicoes'
                ? 'modal-settings-condicoes'
                : 'modal-settings'
            }
          >
            <p
              style={{ marginBottom: 5 }}
              onClick={() => this.executeFunction(editItem)}
            >
              <img src={edit} alt="edit" />
              Editar
            </p>
            {blt !== 'intencoes' &&
            user &&
            user.selectedCompany?.claim?.name !== 'Viewer' ? (
              <p onClick={() => this.executeFunction(deleteItem)}>
                <img src={delet} alt="delete" />
                Excluir
              </p>
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ia: state.intelligence.ia,
  bot: state.bots.bot,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...IaCreators,
      ...BotsCreators,
      ...UserActions,
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(memo(SettingsCard)))
);
